// Pulseira do cliente do cardápio (achados 92 e 114, 27/10/2026): o backend
// devolve `cliente_token` quando o cliente entra pelo telefone, e cartão salvo,
// perfil, CPF e endereços passam a exigir o cabeçalho X-Cliente-Token dele.
// Fica numa chave própria porque o objeto "client" é regravado inteiro quando
// o cliente edita o perfil.
const CHAVE = "cliente_token";

export function guardarPulseira(token) {
  try {
    if (token) localStorage.setItem(CHAVE, token);
    else localStorage.removeItem(CHAVE);
  } catch { /* navegador sem armazenamento: o cliente entra de novo */ }
}

export function lerPulseira() {
  try { return localStorage.getItem(CHAVE) || ""; } catch { return ""; }
}

export const esquecerPulseira = () => guardarPulseira("");

/** Cabeçalhos das rotas do cliente: a pulseira e, se houver, o login da loja
 *  (Totem e painel chamam as mesmas telas com o login da equipe). */
export function cabecalhosDoCliente() {
  const h = {};
  const pulseira = lerPulseira();
  if (pulseira) h["X-Cliente-Token"] = pulseira;
  try {
    const equipe = localStorage.getItem("token");
    if (equipe) h.Authorization = `Bearer ${equipe}`;
  } catch { /* sem armazenamento */ }
  return h;
}

/** Para axios: `axios.get(url, comPulseira())`. */
export const comPulseira = () => ({ headers: cabecalhosDoCliente() });
